module.exports = __webpack_public_path__ + "img/background005.jpg";